import { render, staticRenderFns } from "./TeamMappingModal.vue?vue&type=template&id=defcb880&scoped=true&"
import script from "./TeamMappingModal.vue?vue&type=script&lang=js&"
export * from "./TeamMappingModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamMappingModal.vue?vue&type=style&index=0&id=defcb880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defcb880",
  null
  
)

export default component.exports